import { Departments } from "../../Logic/EmsAPI/mailboxAccessRequest";
import Confirm from "../Generic/ConfirmDialog";
import { MailboxAccessRequest } from "./tenantApiCall";

export interface MailboxAccessRequestDetailsModalProps {
    request: MailboxAccessRequest;
    departments: Array<Departments>;
    onClose: () => void;
}

function MailboxAccessRequestDetailsModal(props: MailboxAccessRequestDetailsModalProps) {
    const { request, departments, onClose } = props;

    function getDepartmentNameById(departmentId?: number): string {
        return departments.find(department => department.id === departmentId)?.name ?? "";
    }

    return (
        <Confirm
            title="Request Details"
            onConfirm={onClose}
        >
            <table
                className="roles-table"
                style={{ marginLeft: "0px", width: "600px" }}
            >
                <tbody>
                    <tr>
                        <td style={{ width: "60%" }}>
                            <table
                                className="roles-table"
                                style={{ marginLeft: "0px" }}
                            >
                                {" "}
                                <tr>
                                    <td>Firstname</td>
                                    <td>{request.user.firstName}</td>
                                </tr>
                                <tr>
                                    <td>Lastname</td>
                                    <td>{request.user.lastName}</td>
                                </tr>
                                <tr>
                                    <td>Department Name</td>
                                    <td>{getDepartmentNameById(request.user.departmentID)}</td>
                                </tr>
                                <tr>
                                    <td>External User ID</td>
                                    <td>{request.user.externalUserID}</td>
                                </tr>
                                <tr>
                                    <td>Role Name</td>
                                    <td>{request.roleName}</td>
                                </tr>
                                <tr>
                                    <td>Mailbox Name</td>
                                    <td>{request.mailboxName}</td>
                                </tr>
                                <tr>
                                    <td>Telephone Number</td>
                                    <td>{request.user.telephone}</td>
                                </tr>
                                <tr>
                                    <td>Email</td>
                                    <td>
                                        {" "}
                                        {request.user.profile_email == undefined ? "" : request.user.profile_email}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Mobile</td>
                                    <td>{request.user.mobile}</td>
                                </tr>
                                <tr>
                                    <td>Business Title</td>
                                    <td>
                                        {request.user.profile_jobTitle == undefined
                                            ? request.user.email
                                            : request.user.profile_jobTitle}
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td valign="top">
                            <div
                                style={{
                                    width: "100%",
                                    height: "284px",
                                    overflowY: "auto",

                                    padding: "5px",
                                    paddingTop: "0px",
                                }}
                            >
                                <b>Motivation comment:</b>
                                <p>{request.motivationComment}</p>
                                <b>Reason for decline:</b>
                                <p>{request.declineReason}</p>
                                <br />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </Confirm>
    );
}
export default MailboxAccessRequestDetailsModal;
